import React from 'react';
import CallDetailBlock from '@/views/event_detail/CallDetailBlock';
import {CallEvent, EventTextField} from 'entities/event';

export interface Props {
    eventData: CallEvent;
    fieldToShow?: EventTextField;
    autoScrollScope?: 'event' | 'search' | 'textSamples';
}

const CallTextSampleModalContents = React.memo<Props>(({eventData, autoScrollScope = 'textSamples'}) => (
    <CallDetailBlock eventData={eventData} autoScrollScope={autoScrollScope} />
));

export default CallTextSampleModalContents;
